/* eslint-disable no-unused-expressions */
import CounterService from './Module/Timer/counterService.js';
import EndGameAlert from './Module/Timer/endGameAlert.js';
import EnterCodeAction from './Module/enterCodeAction.js';
import HintsAttemptsAction from './Module/hintsAttemptsAction.js';
import HintsDatabaseWriter from './Module/hintsDatabaseWriter.js';
import PrimaryKeyAction from './Module/primaryKeyAction.js';
import SessionCreateAction from './Module/sessionCreateAction.js';
import StartButtonAction from './Module/startButtonAction.js';
import ThreeAttempsMode from './Module/threeAttempsMode.js';
import UserJoinGroupAction from './Module/userJoinGroupAction.js';

const gameState = data_handler.gameState,
	threeStrikeGame = data_handler.threeStrikeGame;

const DOMElements = {
	gameTimerDisplay: '#game-timer-display',
};

const gameTimerDisplay = document.querySelector(DOMElements.gameTimerDisplay);

const checkGameStatus = () => {
	if (gameState === 'game_running') {
		CounterService.grouptimerfunction();
	} else if (gameState === 'game_finished') {
		if (gameTimerDisplay) {
			gameTimerDisplay.innerHTML = 'Game over...';
		}
	}
};

const init = () => {
	console.log('App started'), checkGameStatus();
	PrimaryKeyAction.bindEvents();
	SessionCreateAction.bindEvents();
	UserJoinGroupAction.bindEvents(),
		UserJoinGroupAction.userJoinGroupSocketListener();
	StartButtonAction.bindEvents(),
		StartButtonAction.startButtonSocketListener();
	EnterCodeAction.bindEvents(), EnterCodeAction.enterCodeSocketListener();
	HintsAttemptsAction.bindEvents(), HintsAttemptsAction.hintsSocketListener();
	HintsDatabaseWriter.bindEvents();
	EndGameAlert.watchTimeLeft(), EndGameAlert.bindEvents();
	if (threeStrikeGame === 'on') {
		ThreeAttempsMode.bindEvents(),
			ThreeAttempsMode.enterCodeSocketListener();
	}
};
init();
